import React, { useState, useEffect } from "react";
import _ from "lodash";
import Step1 from "./steps/step1";
import Step2 from "./steps/step2";
import Step3 from "./steps/step3";
import { requestSuccess } from "utils/requestHandler";

const PurchaseForm = (props) => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({});
  const [selectedItem, setSelectedItem] = useState([]);

  useEffect(() => {
    props.getParamOptions("paymentOptions", "PaymentType");
    props.getProductsOptions();
    if (props.getSubAdminRoles) {
      props.getSubAdminRoles();
    }
    // props.getUnitUserCapacity();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [step]);

  useEffect(() => {
    let tmpItems = [];
    _.map(formData.step1?.items, (value, key) => {
      if (value > 0) {
        tmpItems.push({ ..._.find(props.productList, { ID: key }), quantity: value });
      }
    });
    setSelectedItem(tmpItems);
  }, [formData.step1]);

  const salesPayload = (value, type = "unit", bindID) => {
    console.log("Sales Type:", type); // ✅ Debugging to check if type is undefined

    const paymentPurpose = {
      addOn: "4",
      FSP: "3",
      unit: formData.step2?.lot?.loanDetails?.installmentMonth > 1 ? "1" : "8",
    };

    const salesType = {
      addOn: "4",
      FSP: "3",
      unit: "2",
    };

    if (!salesType[type]) {
      console.error(`Invalid sales type received: ${type}`);
      return null; // Prevent further processing if type is invalid
    }

    const step2Details = {
      loanDetails: {
        installmentMonth: 1,
        sumPerInstallment: 1,
      },
      ...formData.step2?.lot,
      downpayment: formData.step2?.lot?.downpayment,
      backWallAmount: props.isBurial ? formData.step2?.lot?.backWallAmount || 0 : 0,
    };

    const bindUnitBookingID = props.bookingOrder?.SalesId || "";

    let items = [];
    if (type === "addOn") {
      items = selectedItem.map((val) => ({
        productCode: val.ProductCode,
        quantity: val.quantity,
        productID: val.ID,
        productName: val.ProductName,
        singlePrice: val.Price,
        totalPrice: val.quantity * val.Price,
      }));
    } else if (type === "FSP") {
      items = [
        {
          // bindUnitBookingID: bindUnitBookingID,
          productCode: props.selectedSlot?.ProductCode,
          quantity: 1,
          productID: props.selectedSlot?.ID,
          productName: props.selectedSlot?.ProductName,
          singlePrice: props.bookingOrder?.AgreedPrice ?? props.selectedSlot?.Price,
          totalPrice: props.bookingOrder?.AgreedPrice ?? props.selectedSlot?.Price,
          paymentDetails: step2Details,
        }
      ];
    }

    return {
      salesByID: props.profile?.MemberId,
      purchaserID: formData.step1?.purchaserID?.MemberId,
      memberID: formData.step1?.memberID?.MemberId,
      paymentType: value.paymentType?.toString(),
      salesDate: value.salesDate,
      remarks: value.remarks,
      receipt: value.receipt?.base64 !== undefined ? value.receipt.base64 : "",
      salesType: salesType[type] || "2", // ✅ Ensure a fallback salesType if undefined
      paymentPurpose: paymentPurpose[type] || "1",
      bindUnitSalesID: bindID,
      introducerDetail: value.introducerDetail,
      unitID: type !== "FSP" ? props.selectedSlot?.UnitID : undefined,
      lot: type === "unit" ? step2Details : undefined,
      items: items.length > 0 ? items : [],
      bindUnitBookingID: bindUnitBookingID,
      needCondition: formData.step1?.needCondition,
      // intendedUsers: formData.step1?.intendedUsers || [],
      intendedUsers: value.intendedUsers || [],

    };
  };





  const finalizeProcess = (message) => {
    props.onChangeHOC("page", "listing");
    props.onChangeHOC("selectedSlot", {});
    props.getFloorPlan(props.selectedArea);
    requestSuccess(message);
  };


  return (
    <>
      <div>
        {step === 1 && (
          <Step1
            {...props}
            formData={formData.step1}
            disabledPurchaserID={props.disabledPurchaserID}
            hideCreateNewPurchaser={props.hideCreateNewPurchaser}
            onNext={(value) => {
              setStep(step + 1);
              setFormData({
                ...formData,
                step1: value,
              });
            }}
          />
        )}
        {step === 2 && (
          <Step2
            {...props}
            formData={formData.step2}
            onNext={(value) => {
              setStep(step + 1);
              setFormData({ ...formData, step2: value });
            }}
            onBack={(value) => {
              setStep(step - 1);
              setFormData({ ...formData, step2: value });
            }}
          />
        )}
        {step === 3 && (
          <Step3
            {...props}
            formData={formData}
            selectedItem={selectedItem}
            disabledPORefNo={props.disabledPORefNo}
            onNext={(value) => {
              // Format the salesDate
              const formattedDate = value.Date?.format?.("YYYY-MM-DD");

              // Extract intended users from Step 1
              const intendedUsers = Object.keys(formData.step1 || {})
                .filter((key) => key.startsWith("intendedUser"))
                .map((key) => formData.step1[key])
                .filter((user) => user && user.fullName); // Optional: only include if fullName exists

              // Merge into clean value
              const cleanValue = {
                ...value,
                salesDate: formattedDate,
                intendedUsers,
              };

              // Save into step3 state
              setFormData({ ...formData, step3: cleanValue });

              // Build payloads
              const unitPayload = salesPayload(cleanValue, "unit");
              const addOnPayload = salesPayload(cleanValue, "addOn");

              if (props.salesType === "FSP") {
                props.createSales(salesPayload(cleanValue, "FSP"), (response) => {
                  if (_.isEmpty(props.bookingOrder)) {
                    props.onChangeServiceHOC("showBookingForm", false);
                    props.onChangeServiceHOC("showPurchaseForm", false);
                    props.onChangeServiceHOC("selectedPackage", {});
                  } else {
                    props.onChangeHOC("selectedSlot", {});
                  }
                  requestSuccess(response.Message);
                });
              } else {
                props.createSales(unitPayload, (unitResponse) => {
                  if (unitResponse?.Data?.salesID) {
                    if (selectedItem.length > 0) {
                      props.createSales(
                        { ...addOnPayload, bindUnitSalesID: unitResponse.Data.salesID },
                        (addOnResponse) => {
                          finalizeProcess(addOnResponse.Message);
                        }
                      );
                    } else {
                      finalizeProcess(unitResponse.Message);
                    }
                  }
                });
              }
            }}


            // Helper function to finalize the process and update UI state


            onBack={(value) => {
              setStep(step - 1);
              setFormData({ ...formData, step3: value });
            }}
          />
        )}
      </div>
    </>
  );
};

export default PurchaseForm;
